import axios from "axios";

export default axios.create({
    // baseURL: "https://127.0.0.1:8000/api"
    baseURL: "https://mijn.dedolleinstuivers.nl/api/public/api"
})